var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no_data",style:({
        height: `${_vm.height}px`,
    })},[_c('div',{staticClass:"center"},[_c('GI',{staticClass:"icon_unfind",attrs:{"name":"global_404"}}),_c('span',[_vm._v(_vm._s(_vm.langJson('No Data')))])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }